import { connect, useSelector } from 'react-redux';

const withRbVisitorID = connect(s => {
  return { rbVisitorID: s.rbVisitorID };
});

export const useRbVisitorID = () => useSelector(s => s.rbVisitorID);

export default withRbVisitorID;
